

export const AUTO_PLAN_RC = "responsabilidadCivil";